export const UPDATE = "users/UPDATE";
export const APPEND = "users/APPEND";
export const UPDATE_ONE = "users/UPDATE_ONE";
export const DESTROY = "users/DESTROY";
export const LOADING = "users/LOADING";
